import { render, staticRenderFns } from "./LoginB.vue?vue&type=template&id=76d97c6c&scoped=true&"
import script from "./LoginB.vue?vue&type=script&lang=js&"
export * from "./LoginB.vue?vue&type=script&lang=js&"
import style0 from "./LoginB.vue?vue&type=style&index=0&id=76d97c6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d97c6c",
  null
  
)

component.options.__file = "LoginB.vue"
export default component.exports